// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stackBarLabels g[alert] {
  --vis-xy-label-stroke-color: white;
  --vis-xy-label-stroke-width: 1px;
}

.stackBarLabels g[alert][cluster] {
  --vis-xy-label-stroke-width: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/examples/xy-components/xy-labels/labels-stacked-bar/style.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".stackBarLabels g[alert] {\n  --vis-xy-label-stroke-color: white;\n  --vis-xy-label-stroke-width: 1px;\n}\n\n.stackBarLabels g[alert][cluster] {\n  --vis-xy-label-stroke-width: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stackBarLabels": `stackBarLabels`
};
export default ___CSS_LOADER_EXPORT___;
